import { DataBean } from "../DataBean";

export class SocialSecuritySpreadSheet extends DataBean {



    public async deleteSocialSecuritySpreadSheet(idSocialSecuritySpreadSheet: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSocialSecuritySpreadSheet_Number", [idSocialSecuritySpreadSheet]);
    }

    public async getSocialSecuritySpreadSheetCatalog(year: any, month: any, regexStr: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecuritySpreadSheetCatalog_Number_Number_String", [year, month, regexStr]);
    }

    public async importFilesToSocialSecuritySpreadSheet(idSocialSecuritySpreadSheet: number, idSocialSecurityTemplate: number, filename: string, directory: string, dataStore: string, deleteAll: boolean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importFilesToSocialSecuritySpreadSheet_Number_Number_String_String_String_Boolean", [idSocialSecuritySpreadSheet, idSocialSecurityTemplate, filename, directory, dataStore, deleteAll]);
    }

    public async createSocialSecuritySpreadSheetAdjustment(idSocialSecuritySpreadSheet: number, accountantDate: any, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createSocialSecuritySpreadSheetAdjustment_Number_java.util.Date_Number", [idSocialSecuritySpreadSheet, accountantDate, idEmployee]);
    }

    public async getSocialSecurityTemplateList(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecurityTemplateList_Number", [arg]);
    }

}